import * as React from 'react';

var _g, _defs;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgPizza(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pizza_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.762 19.491c-.03.1-.08.19-.147.27v.002c-.621.75-2.704.691-3.92.227 0 0-.459-.126-.417.425a.944.944 0 00.015.12c.072.415.29 1.25.256 1.97-.02.474-.148.898-.495 1.123-.495.324-1.255.427-1.73.027-.363-.301-.56-.895-.353-1.901 0 0 .549-1.602.238-2.026-.312-.424-1.037-.278-1.38.064-.342.34-1.827.943-2.581-.026-.755-.969-.98-1.804-2.957-2.343a13.925 13.925 0 01-1.696-.608 25.69 25.69 0 01-.933-.413c-1.259-.587-2.299-1.169-2.299-1.169l.11-5.972 6.171-5.133 3.11-.878 1.054 1.71 2.854 4.635 1.62 2.631 2.764 4.487.192.313s.832 1.436.524 2.465z",
    fill: "#FFC907"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.066 15.635c1.562 0 2.828-1.285 2.828-2.87 0-1.585-1.266-2.87-2.828-2.87-1.562 0-2.828 1.285-2.828 2.87 0 1.585 1.266 2.87 2.828 2.87zM22.044 16.713a2.813 2.813 0 01-2.31 1.217c-1.562 0-2.828-1.286-2.828-2.87 0-1.429 1.028-2.614 2.375-2.833l2.763 4.486zM17.662 9.596a2.663 2.663 0 01-1.107.239c-1.501 0-2.72-1.236-2.72-2.76 0-.85.38-1.61.973-2.114l2.854 4.635z",
    fill: "#F8555B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.052 9.285a.485.485 0 01-.388-.194c-.647-.857-1.772-.365-1.82-.343a.487.487 0 01-.645-.25.498.498 0 01.243-.654c.644-.298 2.1-.546 2.998.643a.501.501 0 01-.09.696.482.482 0 01-.298.102zM13.012 18.312a.492.492 0 01-.488-.467.493.493 0 01.457-.524c.02-.001.723-.061 1.137-.564.263-.32.366-.772.305-1.344a.495.495 0 01.433-.547.49.49 0 01.539.44c.091.856-.089 1.562-.535 2.098-.694.832-1.774.905-1.82.907h-.028zM16.881 12.314c-1.391 0-2.402-1.055-2.449-1.104a.5.5 0 01.016-.702.483.483 0 01.69.015c.015.017.926.95 2.018.778a.49.49 0 01.558.415.495.495 0 01-.409.566 2.765 2.765 0 01-.424.032zM7.871 15.66c-.003.007-.229.54-.278 1.155-.315-.132-.63-.273-.933-.414.098-.633.303-1.11.317-1.141a.486.486 0 01.645-.252c.246.11.358.403.249.653z",
    fill: "#34DDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.596 3.784c-.24.557-.69.994-1.25 1.216-3.429 1.36-5.298 3.866-6.263 5.73-1.014 1.96-1.274 3.643-1.283 3.7a2.289 2.289 0 01-.867 1.5 2.27 2.27 0 01-1.68.454l-.531-.07a2.262 2.262 0 01-1.506-.875 2.297 2.297 0 01-.45-1.69c.012-.095.066-.471.2-1.049.137-.585.357-1.376.702-2.29a19.562 19.562 0 01.91-2.043C3.826 5.957 6.15 2.783 10.274.776c.388-.189.792-.368 1.212-.534a2.265 2.265 0 012.945 1.29l.197.502a2.3 2.3 0 01-.032 1.75z",
    fill: "#C96A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.562 2.203c-4.199 1.872-6.83 6.934-6.856 6.985a.732.732 0 01-.988.317.744.744 0 01-.394-.629c.081-.167.165-.337.254-.507C3.826 5.959 6.15 2.785 10.274.777a.733.733 0 01.664.445.749.749 0 01-.377.981zM2.892 11.163l-.533 1.564a.734.734 0 01-.932.46.741.741 0 01-.462-.488c.136-.585.357-1.376.702-2.29.19-.205.49-.29.771-.192a.747.747 0 01.454.946z",
    fill: "#DE8941"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pizza_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.082 .082)",
    d: "M0 0h23.833v23.833H0z"
  })))));
}

export { SvgPizza as default };